import { createSlice } from "@reduxjs/toolkit";
import { getJobCardList, searchJobCardList } from "../../reduxApi/admin/JobCardReduxApi";

const jobCardSlice = createSlice({
    name: 'JobCard',
    initialState: {
        status: 'idel',
        isFiltered: false,
        jobCards: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteJobCardAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.jobCards.findIndex((item) => item.id === id);
                if (index !== -1) {
                    state.jobCards.splice(index, 1);
                }
            });
        },
        updateJobCardAction: (state, action) => {
            const index = state.jobCards.findIndex(
                (item) => item.ROWID === action.payload.ROWID
            );

            if (index !== -1) {
                state.jobCards[index] = action.payload;
            }
        },
        addJobCardAction: (state, action) => {
            state.jobCards.unshift(action.payload);
        },

        clearFilters: (state) => {
            state.isFiltered = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getJobCardList.pending, (state) => {
            state.status = 'pending'
        })
            .addCase(getJobCardList.fulfilled, (state, action) => {
                state.status = 'fulfilled';

                const rawData = action.payload?.data?.data || [];

                const jobCards = rawData.map(item => item.parent);

                // const uniqueJobCards = Object.values(
                //     jobCards.reduce((acc, curr) => {
                //         acc[curr.ROWID] = curr;
                //         return acc;
                //     }, {})
                // );
                const uniqueJobCards = Object.values(
                    jobCards.reduce((acc, curr, index) => {
                        const key = curr.ROWID || index; // fallback
                        acc[key] = curr;
                        return acc;
                    }, {})
                );

                state.jobCards = uniqueJobCards;
                // state.isFiltered = false;
            });
    },
});

export const { deleteJobCardAction, updateJobCardAction, addJobCardAction, setFilteredStatus, clearFilters } = jobCardSlice.actions
export default jobCardSlice.reducer